import type { components } from '@/types/apiSchema';

export interface RecordPrescreenCallStartedInput {
  candidateJobId: string;
  conversationId: string;
  copyVersion: NonNullable<
    components['schemas']['PrescreeningCallStartedRequest']['copyVersion']
  >;
}

export const PRESCREEN_CALL_STARTED_RETRY_COUNT = 2;

function isTransientPrescreenCallStartedError(error: unknown): boolean {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return true;
  }

  const message = error instanceof Error ? error.message : '';
  const status =
    error &&
    typeof error === 'object' &&
    'status' in error &&
    typeof error.status === 'number'
      ? error.status
      : undefined;

  if (status !== undefined) {
    return status >= 500 && status < 600;
  }

  return (
    message.includes('Network Error') ||
    message.includes('Failed to fetch') ||
    /HTTP 5\d{2}\b/.test(message)
  );
}

export function createPrescreenCallStartedRequest({
  candidateJobId,
  conversationId,
  copyVersion,
}: RecordPrescreenCallStartedInput) {
  return {
    params: {
      path: {
        candidateJobId,
      },
    },
    body: {
      conversationId,
      copyVersion,
    },
  };
}

export function shouldRetryPrescreenCallStarted(
  failureCount: number,
  error: unknown,
): boolean {
  return (
    failureCount < PRESCREEN_CALL_STARTED_RETRY_COUNT &&
    isTransientPrescreenCallStartedError(error)
  );
}
